export default "__VITE_ASSET__36G6B6ah__"